import axios from '@/jslib/axios'
import {productAPiPath} from '@/utils/smePath'
export const getPolicyList = (params,isPrivate=false) => {
  let path = isPrivate?'/admin/policy/product/list':'/admin/policy/list'
  return axios({
    method: 'get',
    url: path,
    params
  })
}

export const getPolicyDetail = (params,productId=11) => {
  return axios({
    method: 'get',
    url: `/admin/order/${productAPiPath[productId]}/policy/detail`,
    params
  })
}
// export const getPolicyDetail = params => {
//   return axios({
//     method: 'get',
//     url: '/admin/order/car/policy/detail',
//     params
//   })
// }

export const getHousemaidPolicyDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/housemaid/policy/detail',
    params
  })
}

export const getInteriorPolicyDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/interior/policy/detail',
    params
  })
}

export const getHomefirePolicyDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/home_fire/policy/detail',
    params
  })
}
export const getTravelPolicyDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/travel/policy/detail',
    params
  })
}
export const getStudentPolicyDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/student/policy/detail',
    params
  })
}
export const getWorkingPolicyDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/holiday/policy/detail',
    params
  })
}
export const getPersonalPolicyDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/accident/policy/detail',
    params
  })
}

export const getManualPolicyDetail = params => {
  return axios({
    method: 'get',
    // url: '/admin/order/manual/policy/detail',
    url: '/admin/sme/policy/detail',
    params
  })
}

export const addManualPolicyInvoice = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/policy/invoice/add',
    data
  })
}

export const editManualPolicyInvoice = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/policy/invoice/edit',
    data
  })
}

export const getPolicyDocumentList = params => {
  return axios({
    method: 'get',
    url: '/admin/policy/document/incomplete/list',
    params
  })
}

export const addPolicyRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/policy/remark/add',
    data
  })
}

export const editManualFile = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/file/upload',
    data,
    timeout: 120000
  })
}

export const addSmePayment = data => {
  return axios({
    method: 'post',
    url: '/admin/payment/for/sme',
    data
  })
}

export const editSmePayment = data => {
  return axios({
    method: 'patch',
    url: '/admin/payment/for/sme',
    data
  })
}
export const enterManualPolicyNo = data => {
  return axios({
    method: 'post',
    url: '/admin/order/manual/enter/pcy_no',
    data
  })
}
export const addHoldDollars = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/add/hold_dollars',
    data
  })
}
export const getPolicyDetailLog = params => {
  return axios({
    method: 'get',
    url: '/admin/policy/log/list',
    params
  })
}
export const getPolicyExportList = params => {
  return axios({
    method: 'get',
    url: '/admin/policy/export/list',
    // responseType: 'blob',
    params,
    timeout: 120000
  })
}
export const getOrderAdjustPremium = params => {
  return axios({
    method: 'get',
    url: '/admin/order/adjust/detail/change',
    params
  })
}

export const changeTag = params => {
  return axios({
    method: 'post',
    url: '/admin/policy/tag/change',
    params
  })
}

export const manualPolicyFileSave = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/policy/file/save',
    data
  })
}

export const manualPolicyFileDel = data => {
  return axios({
    method: 'delete',
    url: '/admin/manual/policy/file/delete',
    data
  })
}

export const issueApi = data => {
  return axios({
    method: 'post',
    url: '/admin/order/issue/api',
    data
  })
}

export const pcyPDFApi = data => {
  return axios({
    method: 'post',
    url: '/admin/order/api/pcy_pdf ',
    data
  })
}

export const issueCNApi = data => {
  return axios({
    method: 'post',
    url: '/admin/order/issue/api ',
    data
  })
}

export const submitCoverNote = params => {
  return axios({
    method: 'get',
    url: '/admin/bot/covernote/submit',
    params
  })
}

export const loadCoverNote = params => {
  return axios({
    method: 'get',
    url: '/admin/bot/covernote/loading',
    params
  })
}
export const getExtraBenefitsList = params => {
  return axios({
    method: 'get',
    url: '/admin/policy/extra/benefit/list',
    params
  })
}
export const getExtraBenefitsExportList = params => {
  return axios({
    method: 'post',
    url: '/admin/marketing/report/export',
    responseType: 'blob',
    params,
    timeout: 120000
  })
}
